export class CapsuleUnitMeasure {
    constructor(
        public measureId: number,
        public measureName: string,
        public measure: number,
        public total_measure: number,
        public unitName: string,
        public longUnitName: string,
        public isDefault: number
    ) { }
}